<template>
    <e-modal
        v-model="isQuizEditorOpen"
        :can-cancel="[]"
        scroll="keep"
        full-screen
        custom-class="quiz-builder-container"
    >
        <quiz-builder :uuid="quizUuid" :is-new="quizIsNew" @close="isQuizEditorOpen = false" />
    </e-modal>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

import QuizBuilder from '@/components/quiz-builder/QuizBuilder.vue';

const store = useStore();

const isQuizEditorOpen = computed({
    get() {
        return store.state.QuizBuilder.modalIsOpen;
    },

    set(newValue) {
        store.commit('QuizBuilder/SET_MODAL_IS_OPEN', newValue);
    },
});

const quizUuid = computed(() => store.state.QuizBuilder.modalQuizUuid);
const quizIsNew = computed(() => store.state.QuizBuilder.modalQuizIsNew);
</script>
